<template>
  <el-scrollbar ref="scrollbar" style="height: 100%;">
    <canvas v-for="page in pages" :id="'the-canvas'+page" :key="page" style="width: 100%;height:100%"></canvas>
  </el-scrollbar>
</template>

<script>
  import PDFJS from 'pdfjs-dist';
  import {base64ToBinary, base64toUint8Array} from '../libs/common';

  const IFRAME_ID_PRINT = 'iframe_id_print'

  export default {
    data() {
      return {
        pages: 0,
        pdfDoc: null,
        unit8Array: null,
        pdfData: null,
      }
    },
    props: {
      //pdf base64
      pdfBase64: {
        type: String
      },
    },
    methods: {
      /**
       *
       * @param val
       * @param onReady
       * 渲染完成时的回调
       */
      showPdf: function (base64, onReady) {
        const _this = this;

        _this.$emit('onPdfLoading');

        let data = base64toUint8Array(base64);
        let loadingTask = PDFJS.getDocument(data)

        _this.pdfData = 'data:application/pdf;base64,' + base64;
        loadingTask.then(function (pdf) {
          _this.pdfDoc = pdf
          _this.pages = _this.pdfDoc.numPages
          _this.$nextTick(() => {
            _this.renderPage(1)
          });
          _this.$emit('onPdfLoaded');
        }).catch(function (err) {
          _this.$emit('onPdfLoadFail');
        });
      },
      /**
       * 渲染呈现pdf
       * @param num
       */
      renderPage(num) {
        let _this = this
        this.pdfDoc.getPage(num).then(function (page) {
          let canvas = document.getElementById('the-canvas' + num)
          let ctx = canvas.getContext('2d')
          let dpr = window.devicePixelRatio || 1
          let bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1
          let ratio = dpr / bsr
          var viewport = page.getViewport(screen.availWidth / page.getViewport(1).width)
          canvas.width = viewport.width * ratio
          canvas.height = viewport.height * ratio
          //canvas.style.width = viewport.width + 'px'
          //canvas.style.height = viewport.height + 'px'
          canvas.style.width = "100%"
          canvas.style.height = "100%"
          ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
          var renderContext = {
            canvasContext: ctx,
            viewport: viewport
          }
          page.render(renderContext)
          if (_this.pages > num) {
            _this.renderPage(num + 1)
          }
        })
      },
      /**
       * 打印
       */
      print() {
        const _this = this;

        if (!_this.pdfData) {
          _this.$alert('pdfData为空');
          return;
        }

        function removeIframe() {
          iframeElt.parentNode.removeChild(iframeElt);
        }

        $('#' + IFRAME_ID_PRINT).remove();
        let iframeElt = document.createElement('iframe');
        iframeElt.id = IFRAME_ID_PRINT;
        iframeElt.frameBorder = '0';
        iframeElt.scrolling = 'no';
        iframeElt.width = '0px;'
        iframeElt.height = '0px;'

        new Promise(function (resolve, reject) {
          let pdfDataBinary = base64ToBinary(_this.pdfData);

          const url = window.URL.createObjectURL(pdfDataBinary);
          iframeElt.src = url;

          iframeElt.onload = function () {
            resolve(this.contentWindow);
          }

          window.document.body.appendChild(iframeElt);
        }).then(function (win) {
          win.focus(); // Required for IE
          if (win.document.queryCommandSupported('print')) {
            win.document.execCommand('print', false, null);
          } else {
            win.print();
          }
        }).catch(function (err) {
          removeIframe();
          // emitEvent('error', err);
        });
      },
      //点击关闭
      close: function () {
        this.$emit('onClose');
      },
      //关闭后，供外部调用
      reset: function () {
        this.numPages = 0;
        this.pdfData = null;
        this.src = '';
      },
    },
    mounted() {
      //this.showPdf('', null);
    },
    watch: {
      pdfBase64: {
        immediate: true,
        handler(val, oldVal) {
          if (!val) return;
          this.showPdf(val);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PdfViewer.vue